module.exports = __webpack_public_path__ + "img/TXT.cc6c0ed1.svg";